import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const taxfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {

  const formFields = [
    {
      label: 'Tax Name',
      key: 'name',
      type: 'text',
      placeholder: 'Enter the tax name',
      visible: true,
      width: '25%',
    },
    {
      label: 'Tax Type',
      key: 'tax_type',
      type: 'select',
      placeholder: 'Select the tax type',
      visible: true,
      width: '25%',
      options: response.tax_types || [],
    },
    {
      label: 'Tax Percentage',
      key: 'tax_percentage',
      type: 'number',
      placeholder: 'Enter the tax percentage',
      visible: true,
      width: '25%',
    },
    {
      label: 'Input Account',
      key: 'input_account_id',
      type: 'select',
      placeholder: 'Select the input account',
      visible: true,
      width: '25%',
      options: response.accounts || [],
    },
    {
      label: 'Output Account',
      key: 'output_account_id',
      type: 'select',
      placeholder: 'Select the output account',
      visible: true,
      width: '25%',
      options: response.accounts || [],
    }
  ];

  const CustomFields = response.CustomFields;

  if (CustomFields && CustomFields.length > 0) {
    CustomFields.forEach((field) => {
      formFields.push({
        label: field.name,
        key: 'cf.' + field.key,
        type: field.type,
        placeholder: field.placeholder,
        visible: true,
        width: '25%',
        viewField: true,
      });
    });
  }

  return formFields;
}

export const taxMobileCard = (item, index, getFieldValue) => {
  return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
    <View>
      <Text>TEST</Text>
      <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
    </View>
  </Card>;
}

export const taxMain = {
  fields: taxfields,
  mobileCard: null
}
